import React from 'react';
import PropTypes from 'prop-types';
import {Redirect} from 'react-router';

import config from 'config';
import {getPermissions, getUserClients} from '../utils/General';

export const Permissions = ({
                                component: Component, user, company, ...rest
                            }) => (
    <Component
        {...rest}
        user={user}
        company={company}
        clients={getUserClients(user, company)}
        permissions={getPermissions(user, company)}
    />
);

Permissions.propTypes = {
    component: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
    user: PropTypes.object.isRequired,
    company: PropTypes.object.isRequired,
    rest: PropTypes.object,
};

Permissions.defaultProps = {
    rest: {},
};

export const AuthComponent = ({
                                  component: Component, user, requiredPermission, ...rest
                              }) => {
    if (!getPermissions(user).includes(requiredPermission) && requiredPermission !== config.permissions.any) {
        return <Redirect to="/"/>;
    }

    return <Component {...rest} user={user}/>;
};

AuthComponent.propTypes = {
    component: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
    requiredPermission: PropTypes.string.isRequired,
    user: PropTypes.object.isRequired,
    company: PropTypes.object.isRequired,
    rest: PropTypes.object,
};

AuthComponent.defaultProps = {
    rest: {},
};



// WEBPACK FOOTER //
// ./src/components/ComponentSecurity.jsx